<rt-dialog-header
  [heading]="'tlc.ask_hr.form_templates.heading' | translate"
  [subheading]="'tlc.ask_hr.form_templates.subheading' | translate"
/>
<rt-dialog-body>
  <ask-hr-add-new-template (selectedTemplate)="openTemplateEdit($event)" />
</rt-dialog-body>
<ask-hr-setup-banner [canClose]="false" layout-full-width margin-top-medium />
